import React, { useEffect, useMemo, useRef, useState } from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { Button } from "../../Components/Button";
import BusinessStatusBanner from "../../Components/v2/Business/BusinessStatusBanner";
import PeriodLockBanner from "../../Components/v2/Accounting/PeriodLockBanner";
import { isBusinessWriteBlocked } from "../../Constants/business";
import {
  useBusinessTransactionDispatch,
  useBusinessTransactionState,
} from "../../Context/businessTransaction/context";
import {
  clearAccountingTransaction,
  clearAcctTransactionError,
  clearBusinessPartner,
  clearBusinessPartnerError,
  clearDocumentExcelUpload,
  clearGetBusiness,
  clearInitAccountStatus,
  requestCreateAcctTransaction,
  requestCreateBusinessPartner,
  requestCreateBusinessTransaction,
  requestDocumentExcelUpload,
  requestGetBusiness,
  requestInitAccount,
  requestListAccount,
  requestListBusiness,
  requestListBusinessPartner,
  requestListCreditAccount,
  requestListDebitAccount,
  resetNewBusinessTransaction,
  useAccountingDispatch,
  useAccountingState,
  usePeriodLock,
  useAuthState,
} from "../../Context";
import { ModalConfirm } from "../../Components/ModalConfirm";
import { Alert } from "../../Components/Alert";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { NumericFormat } from "react-number-format";
import { useLocation, useNavigate } from "react-router-dom";
import InputSkeleton from "../../Components/InputSkeleton";
import {
  cancelAPIRequest,
  classNames,
  getAccountingFileName,
  getErrorMessages,
  parseTypedClosedDate,
} from "../../Utils";
import { Modal } from "../../Components/Modal";
import { DocumentIcon } from "@heroicons/react/outline";
import FormLabel from "../../Components/FormLabel";
import { Field, Label, Switch } from "@headlessui/react";
import { TRANSACTION_TYPES } from "../../Constants";
import EmptyState from "../../Components/EmptyState";
import { RefreshIcon } from "@heroicons/react/outline";
import EmptyBusiness from "../../Components/EmptyBusiness";
import { downloadData, getUrl } from "aws-amplify/storage";

const transactionTypes = [
  { label: "Income", value: "SALE" },
  { label: "Expense", value: "EXPENSE" },
];

export const CashBookCreate = () => {
  const [selectedBusiness, setSelectedBusiness] = useState();
  const [type, settype] = useState("SALE");
  const [date, setdate] = useState(new Date());
  const [total, settotal] = useState("");
  const [note, setnote] = useState("");
  const [showCashbookSuccess, setshowCashbookSuccess] = useState(false);
  const [showSyncSuccess, setshowSyncSuccess] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showProgressModal, setShowProgressModal] = useState(false);
  const [fieldError, setfieldError] = useState(false);
  const [fieldErrorFile, setfieldErrorFile] = useState({
    status: false,
    message: "",
  });
  const [selectedFile, setselectedFile] = useState("");
  const [accountingSync, setaccountingSync] = useState(false);
  const [transactionType, settransactionType] = useState(null);
  const [debitAccount, setDebitAccount] = useState(null);
  const [creditAccount, setCreditAccount] = useState();
  const [selectedPartner, setselectedPartner] = useState(null);
  const [showPartnerModal, setshowPartnerModal] = useState(false);
  const [showSuccessModal, setshowSuccessModal] = useState(false);

  const [submitted, setsubmitted] = useState(false);
  const [imported, setimported] = useState(false);
  const [businessError, setbusinessError] = useState(null);
  const [dateError, setdateError] = useState(null);
  const [totalError, settotalError] = useState(null);
  const [debitAccountError, setdebitAccountError] = useState(null);
  const [creditAccountError, setcreditAccountError] = useState(null);
  const [fileError, setfileError] = useState(null);

  const [partnerName, setpartnerName] = useState("");
  const [businessType, setbusinessType] = useState("");
  const [partnerNameError, setpartnerNameError] = useState(null);
  const [partnerTypeError, setpartnerTypeError] = useState(null);
  const [partnerSubmitted, setpartnerSubmitted] = useState(false);

  const [downloading, setdownloading] = useState(false);
  const [downloadProgress, setdownloadProgress] = useState(0);
  const [downloadDocError, setdownloadDocError] = useState(null);
  const [showDownloadErrorModal, setshowDownloadErrorModal] = useState(false);
  const downloadRef = useRef(null);

  const { t, i18n } = useTranslation();

  const {
    minDate: periodMinDate,
    isDateClosed,
    isClosed: periodClosed,
    closedThroughLabel,
  } = usePeriodLock(selectedBusiness?.id, { locale: i18n.language });
  const dateLocked = isDateClosed(date);

  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const businessIdParam = searchParams.get("id");
  const sortAccountCode = (a, b) => {
    const aCode = parseInt(a.code, 10);
    const bCode = parseInt(b.code, 10);
    return (aCode < 400000) - (bCode < 400000) || aCode - bCode;
  };

  const dispatch = useBusinessTransactionDispatch();
  const { user } = useAuthState();
  const {
    request: businessPartnerRequest,
    newTransaction,
    error,
    newTransactionLoading,
    newTransactionError,
    businesses,
    business,
    loading: businessLoading,
    uploadError,
    progressUpload,
    storageRequest,
    uploadLoading,
    uploadSuccess,
    businessPartners,
    businessPartnerLoading,
    businessPartnerError,
    newPartner,
    newPartnerLoading,
    newPartnerError,
  } = useBusinessTransactionState();

  const accountingDispatch = useAccountingDispatch();
  const {
    creditAccountRequest,
    debitAccountRequest,
    accounts,
    accountLoading,
    accountError,
    initAccountLoading,
    initAccountStatus,
    debitLoading,
    debits,
    debitError,
    credits,
    creditLoading,
    creditError,
    transactionID,
    submitLoading,
    submitError,
  } = useAccountingState();

  const businessTypes = useMemo(() => {
    return [
      { label: "Personal", value: "PERSONAL" },
      { label: "Incorporated", value: "BUSINESS" },
    ].map((item) => ({
      ...item,
      label: t(item.label),
    }));
  }, [t]);

  useEffect(() => {
    if (transactionID) {
      clearAccountingTransaction(accountingDispatch);
      clearAcctTransactionError(accountingDispatch);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (user.id) {
      requestListBusiness(dispatch, { owner: user.id });
    }
  }, [dispatch, user.id]);

  useEffect(() => {
    if (businessPartnerRequest) {
      cancelAPIRequest(businessPartnerRequest);
    }
    if (selectedBusiness?.id) {
      requestListBusinessPartner(dispatch, {
        page: 1,
        businessID: selectedBusiness?.id,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBusiness?.id]);

  useEffect(() => {
    if (selectedBusiness?.id && accountingSync) {
      requestListAccount(accountingDispatch, {
        businessID: selectedBusiness.id,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBusiness?.id, accountingSync]);

  useEffect(() => {
    if (initAccountStatus === "SUCCESS") {
      requestListAccount(accountingDispatch, {
        businessID: selectedBusiness.id,
      });
      clearInitAccountStatus(accountingDispatch);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initAccountStatus]);

  useEffect(() => {
    if (newTransaction?.id && !accountingSync) {
      setshowCashbookSuccess(true);
    } else if (newTransaction?.id && accountingSync) {
      onAccountingSync();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newTransaction.id]);

  useEffect(() => {
    if (newTransaction?.id && submitError) {
      setshowCashbookSuccess(true);
    }
  }, [newTransaction.id, submitError]);

  useEffect(() => {
    if (transactionID) {
      setshowSyncSuccess(true);
    }
  }, [transactionID]);

  useEffect(() => {
    if (newPartner) {
      setshowSuccessModal(true);
      if (newPartner.id && newPartner.name) {
        setselectedPartner({
          label: newPartner.name,
          value: newPartner.id,
        });
      }
    }
  }, [newPartner]);

  useEffect(() => {
    if (selectedBusiness?.alwaysSync) {
      setaccountingSync(true);
    }
  }, [selectedBusiness?.alwaysSync]);

  useEffect(() => {
    if (businessIdParam) {
      requestGetBusiness(dispatch, { id: businessIdParam });
    }
  }, [businessIdParam, dispatch]);

  useEffect(() => {
    if (business.id) {
      setSelectedBusiness({
        ...business,
        label: business.name,
        value: business.id,
      });
    }
  }, [business]);

  useEffect(() => {
    return () => {
      resetNewBusinessTransaction(dispatch);
      clearGetBusiness(dispatch);
    };
  }, [dispatch]);

  useEffect(() => {
    if (type === "SALE") {
      const selectedType = TRANSACTION_TYPES.find(
        (item) => item.value === "INCOME"
      );
      if (selectedType) {
        settransactionType(selectedType);
        settype("INCOME");
      }
    } else if (type === "EXPENSE") {
      const selectedType = TRANSACTION_TYPES.find(
        (item) => item.value === type
      );
      if (selectedType) {
        settransactionType(selectedType);
      }
    }
  }, [type]);

  useEffect(() => {
    if (debitAccountRequest) {
      cancelAPIRequest(debitAccountRequest);
    }
    if (
      transactionType?.debitAccounts &&
      selectedBusiness?.id &&
      accountingSync
    ) {
      requestListDebitAccount(accountingDispatch, {
        businessID: selectedBusiness.id,
        categories: transactionType.debitAccounts,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transactionType?.debitAccounts, accountingSync, initAccountStatus]);

  useEffect(() => {
    if (creditAccountRequest) {
      cancelAPIRequest(creditAccountRequest);
    }
    if (
      transactionType?.creditAccounts &&
      selectedBusiness?.id &&
      accountingSync
    ) {
      requestListCreditAccount(accountingDispatch, {
        businessID: selectedBusiness.id,
        categories: transactionType.creditAccounts,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transactionType?.creditAccounts, accountingSync, initAccountStatus]);

  useEffect(() => {
    setCreditAccount(null);
    setDebitAccount(null);
  }, [type]);

  useEffect(() => {
    if (uploadSuccess) {
      setShowProgressModal(false);
      setshowCashbookSuccess(true);
    } else if (uploadError) {
      setShowErrorModal(true);
      setShowProgressModal(false);
    }
  }, [uploadSuccess, uploadError]);

  useEffect(() => {
    if (submitted) {
      const isBusinessValid = Boolean(selectedBusiness);
      const isDateValid = Boolean(date);
      const isTotalValid = Boolean(total.value);
      const isDebitAccountValid = Boolean(debitAccount);
      const isCreditAccountValid = Boolean(creditAccount);

      if (isBusinessValid) {
        setErrorMessage("business", "");
      } else {
        setErrorMessage("business", "Business is required.");
      }

      if (isTotalValid) {
        setErrorMessage("total", "");
      } else {
        setErrorMessage("total", "Total is required.");
      }

      if (isDateValid) {
        setErrorMessage("date", "");
      } else {
        setErrorMessage("date", "Date is required.");
      }

      if (isDebitAccountValid) {
        setErrorMessage("debit", "");
      } else {
        setErrorMessage("debit", "Debit account is required.");
      }

      if (isCreditAccountValid) {
        setErrorMessage("credit", "");
      } else {
        setErrorMessage("credit", "Credit account is required.");
      }
    }
  }, [selectedBusiness, date, total, debitAccount, creditAccount, submitted]);

  useEffect(() => {
    if (imported && selectedFile) {
      if (selectedFile) {
        setErrorMessage("file", "");
      } else {
        setErrorMessage("file", "Select a file before clicking Upload.");
      }
    }
  }, [selectedFile, imported]);

  useEffect(() => {
    if (partnerSubmitted) {
      const isNameValid = partnerName.length >= 1;

      if (isNameValid) {
        setErrorMessage("partnerName", "");
      } else {
        setErrorMessage("partnerName", "Partner is required");
      }
    }
  }, [partnerName, partnerSubmitted]);

  useEffect(() => {
    if (partnerSubmitted && businessType.value) {
      const isTypeValid = businessTypes.some(
        (type) => type.value === businessType.value
      );

      if (isTypeValid) {
        setErrorMessage("partnerType", "");
      } else {
        setErrorMessage("partnerType", "Select valid business type.");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [businessType.value, partnerSubmitted]);

  useEffect(() => {
    if (
      selectedBusiness &&
      selectedBusiness?.alwaysSync &&
      accountingSync &&
      type === "INCOME"
    ) {
      const { cashIncomeDebitAccount, cashIncomeCreditAccount } =
        selectedBusiness;
      if (cashIncomeDebitAccount) {
        setDebitAccount({
          ...cashIncomeDebitAccount,
          value: cashIncomeDebitAccount?.id,
          label: `${cashIncomeDebitAccount?.code} - ${cashIncomeDebitAccount?.name}`,
        });
      }
      if (cashIncomeCreditAccount) {
        setCreditAccount({
          ...cashIncomeCreditAccount,
          value: cashIncomeCreditAccount?.id,
          label: `${cashIncomeCreditAccount?.code} - ${cashIncomeCreditAccount?.name}`,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [business, accountingSync, type]);

  useEffect(() => {
    if (
      selectedBusiness &&
      selectedBusiness?.alwaysSync &&
      accountingSync &&
      type === "EXPENSE"
    ) {
      const { cashExpenseDebitAccount, cashExpenseCreditAccount } =
        selectedBusiness;
      if (cashExpenseDebitAccount) {
        setDebitAccount({
          ...cashExpenseDebitAccount,
          value: cashExpenseDebitAccount?.id,
          label: `${cashExpenseDebitAccount?.code} - ${cashExpenseDebitAccount?.name}`,
        });
      }
      if (cashExpenseCreditAccount) {
        setCreditAccount({
          ...cashExpenseCreditAccount,
          value: cashExpenseCreditAccount?.id,
          label: `${cashExpenseCreditAccount?.code} - ${cashExpenseCreditAccount?.name}`,
        });
      }
    }
  }, [selectedBusiness, accountingSync, type]);

  const handleInitAccount = () => {
    requestInitAccount(accountingDispatch, {
      businessID: selectedBusiness?.id,
    });
  };

  const validateInput = () => {
    let currentValidBusiness = true;
    let currentValidDate = true;
    let currentValidTotal = true;

    const isBusinessValid = Boolean(selectedBusiness);
    const isDateValid = Boolean(date);
    const isTotalValid = Boolean(total.value);

    currentValidBusiness = isBusinessValid;
    currentValidDate = isDateValid;
    currentValidTotal = isTotalValid;

    if (accountingSync) {
      let currentValidDebit = true;
      let currentValidCredit = true;

      const isDebitAccountValid = Boolean(debitAccount);
      const isCreditAccountValid = Boolean(creditAccount);

      currentValidDebit = isDebitAccountValid;
      currentValidCredit = isCreditAccountValid;

      return currentValidDebit && currentValidCredit;
    }

    return currentValidBusiness && currentValidDate && currentValidTotal;
  };

  const validatePartnerInput = () => {
    let currentValidPartnerName = true;
    let currentValidType = true;

    const isNameValid = partnerName.length >= 1;
    const isTypeValid = businessTypes.some(
      (type) => type.value === businessType.value
    );

    currentValidPartnerName = isNameValid;

    if (businessType) {
      currentValidType = isTypeValid;
    }

    return currentValidPartnerName && currentValidType;
  };

  const setErrorMessage = (field, message) => {
    switch (field) {
      case "business":
        setbusinessError(message);
        break;
      case "date":
        setdateError(message);
        break;
      case "total":
        settotalError(message);
        break;
      case "file":
        setfileError(message);
        break;
      case "debit":
        setdebitAccountError(message);
        break;
      case "credit":
        setcreditAccountError(message);
        break;
      case "partnerName":
        setpartnerNameError(message);
        break;
      case "partnerType":
        setpartnerTypeError(message);
        break;
      default:
        break;
    }
  };

  const navigateToTransaction = () => {
    clearAccountingTransaction(dispatch);
    setshowCashbookSuccess(false);
    if (!error || !uploadError) {
      if (newTransaction?.id || transactionID) {
        navigate(`/cash-book?id=${selectedBusiness.value}`);
      } else {
        navigate(`/cash-book/import?id=${selectedBusiness.value}`);
      }
    }
  };

  const handleFileUpload = (event) => {
    event.preventDefault();
    const file = event.dataTransfer
      ? event.dataTransfer.files[0]
      : event.target.files[0];
    const maxSize = 100 * 1024; // 100 KB

    if (
      file &&
      file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
      file.size <= maxSize &&
      file.name.length < 120
    ) {
      setfieldErrorFile({ status: false, message: "" });
      setselectedFile(file);
    } else {
      if (!file) {
        setfieldErrorFile({ status: true, message: "Please select a file." });
      } else if (
        file.type !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        setfieldErrorFile({
          status: true,
          message: "The file format must be Excel.",
        });
        event.target.value = "";
      } else if (file.size >= maxSize) {
        setfieldErrorFile({
          status: true,
          message: "File size should not exceed 100 KB",
        });
        event.target.value = "";
      } else if (file.name.length >= 120) {
        setfieldErrorFile({
          status: true,
          message: "The file name is too long, maximum 120 characters.",
        });
        event.target.value = "";
      }
    }
  };

  const handleImportClick = (selectedFile) => {
    setimported(true);
    if (!selectedFile) {
      setErrorMessage("file", "Select a file before clicking Upload.");
    } else {
      if (selectedBusiness) {
        setfieldError(false);
        setShowProgressModal(true);
        requestDocumentExcelUpload(dispatch, {
          businessID: selectedBusiness.id,
          file: selectedFile,
        });
      } else {
        setfieldError(true);
      }
    }
  };

  const handlePartnerSave = () => {
    setpartnerSubmitted(true);
    if (validatePartnerInput()) {
      const input = {
        businessID: selectedBusiness.id,
        name: partnerName,
        type: businessType.value,
      };
      requestCreateBusinessPartner(dispatch, { input });
    }
  };

  const onCreate = () => {
    setsubmitted(true);
    // Blocked only when this entry will also post a journal — a cash-book row
    // on its own is not governed by the accounting period.
    if (accountingSync && dateLocked) return;
    const valid = validateInput();
    if (valid) {
      if (selectedBusiness && type && date && total) {
        setfieldError(false);

        let income = 0;
        let expense = 0;

        if (type === "SALE" || type === "INCOME") {
          income = total.value;
        } else if (type === "EXPENSE") {
          expense = total.value;
        }

        const transactionType = "SALE";

        const transactionData = {
          businessID: selectedBusiness.id,
          income,
          expense,
          type: transactionType,
          createdAt: date.toISOString(),
          note,
        };

        if (selectedPartner?.value) {
          transactionData.partnerID = selectedPartner.value;
        }

        requestCreateBusinessTransaction(dispatch, { input: transactionData });
      } else {
        setfieldError(true);
      }
    }
  };

  const onAccountingSync = () => {
    // Only this path writes a journal; the cash-book record itself is not one.
    if (dateLocked) return;
    if (accountingSync && !newTransactionError) {
      const accountingTransactionData = {
        type: type,
        created_at: date.toISOString(),
        total: total.floatValue,
        accounts: [],
        description: note || "",
        paid: true,
        business_id: selectedBusiness.id,
      };

      if (creditAccount?.value) {
        accountingTransactionData.accounts.push({
          id: creditAccount.value,
          debit: 0,
          credit: accountingTransactionData.total,
        });
      }

      if (debitAccount?.value) {
        accountingTransactionData.accounts.push({
          id: debitAccount.value,
          debit: accountingTransactionData.total,
          credit: 0,
        });
      }

      if (selectedPartner?.value) {
        accountingTransactionData.partner_id = selectedPartner.value;
      }

      requestCreateAcctTransaction(accountingDispatch, {
        input: accountingTransactionData,
      });
    }
  };

  function handleDragOver(event) {
    event.preventDefault();
  }

  function handleDragLeave(event) {
    event.preventDefault();
  }

  function radioTransaction(e) {
    settype(e.target.value);
  }

  const resetPartnerModal = () => {
    setpartnerName("");
    setbusinessType("");
    setpartnerNameError("");
    setpartnerTypeError("");
  };

  const renderProgressBar = (label, percentage) => (
    <div className="flex-1 overflow-hidden">
      <div className="w-full">
        <p className="text-xs text-slate-500">{t(label)}</p>
        <div className="w-full mt-1 bg-gray-200 rounded-md sm:rounded-lg dark:bg-gray-700">
          <div
            className="bg-blue-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full"
            style={{ width: `${percentage}%` }}
          >
            {percentage}%
          </div>
        </div>
      </div>
    </div>
  );

  const renderProgressModal = () => (
    <Modal
      title="Excel Document Upload Process"
      show={showProgressModal}
      onClose={() => {
        setShowProgressModal(false);
      }}
      footer={
        <div className="p-4 flex flex-row-reverse gap-2 justify-between items-center border-t border-gray-300 bg-gray-50 rounded-b-lg">
          {uploadLoading
            ? storageRequest !== null
              ? renderProgressBar(
                  "Uploading",
                  Math.round(
                    (progressUpload?.transferredBytes /
                      progressUpload?.totalBytes) *
                      100
                  ),
                  100
                )
              : renderProgressBar("Uploading Excel Document File", 100)
            : null}
        </div>
      }
    >
      <div className="bg-white p-4">
        <div className="flex flex-col justify-center items-center">
          <DocumentIcon className="h-24 w-24 text-slate-500" />
          <div className="w-full text-center">
            <p className="text-xs text-slate-500 truncate">
              {selectedFile?.name}
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );

  const renderPartnerModal = () => {
    return (
      <Modal
        title={t("Add Partner")}
        show={showPartnerModal}
        onClose={() => {
          setshowPartnerModal(false);
          setpartnerSubmitted(false);
          resetPartnerModal();
          clearBusinessPartnerError(dispatch);
        }}
        footer={
          <div className="p-4 flex justify-end items-center bg-gray-50 rounded-b-lg">
            <Button
              disabled={newPartnerLoading}
              loading={newPartnerLoading}
              onClick={(e) => {
                e.preventDefault();
                handlePartnerSave();
              }}
              className="w-24 shrink-0"
              title="Save"
            />
          </div>
        }
      >
        <div className="flex flex-col gap-4 px-4 py-5">
          {newPartnerError && (
            <Alert
              title="Error"
              type="error"
              message={
                newPartnerError?.message ||
                "newPartnerError delete Transaction."
              }
              errors={newPartnerError?.errors}
            />
          )}
          {newPartner && (
            <ModalConfirm
              open={showSuccessModal}
              setOpen={(open) => {
                setshowSuccessModal(open);
              }}
              title="Success"
              description={"Your new partner has been created."}
              type="SUCCESS"
              onConfirm={() => {
                setshowPartnerModal(false);
                setshowSuccessModal(false);
                clearBusinessPartner(dispatch);
                setpartnerSubmitted(false);
                resetPartnerModal();
              }}
            />
          )}
          <div>
            <FormLabel htmlFor="name" label={t("Name")} required />
            <input
              type="text"
              name="name"
              value={partnerName}
              placeholder={t("Enter Partner Name")}
              onChange={(e) => setpartnerName(e.target.value)}
              className={classNames(
                partnerNameError
                  ? "border-red-500 focus:border-red-500 focus:ring-red-500"
                  : "border-gray-300 focus:border-blue-500 focus:ring-blue-500",
                "mt-1 block w-full text-sm rounded-md shadow-sm"
              )}
            />
            {partnerNameError && (
              <div className="mt-1 text-red-600 text-sm">
                {t(partnerNameError)}
              </div>
            )}
          </div>
          <div>
            <FormLabel htmlFor="type" label={t("Business Type")} />
            <Select
              id="type"
              name="type"
              className={classNames(
                partnerTypeError
                  ? "border-red-500 focus:border-red-500 focus:ring-red-500"
                  : "border-gray-300 focus:border-blue-500 focus:ring-blue-500",
                "mt-1 text-sm"
              )}
              classNamePrefix="select2-selection"
              options={businessTypes}
              value={businessType}
              onChange={setbusinessType}
              placeholder={t("Select Business Type")}
              isLoading={creditLoading}
            />
            {partnerTypeError && (
              <div className="mt-1 text-red-600 text-sm">
                {t(partnerTypeError)}
              </div>
            )}
          </div>
        </div>
      </Modal>
    );
  };

  const renderPartnerError = (error) => {
    const messages = getErrorMessages(error);
    return (
      <div>
        <div className="flex justify-between">
          <FormLabel htmlFor="partner" label={t("Partner or Customer")} />
          {businessIdParam && (
            <button
              type="button"
              onClick={() => {
                setshowPartnerModal(true);
                resetPartnerModal();
              }}
              className="text-blue-600 text-sm font-medium"
            >
              {t("Add Partner")}
            </button>
          )}
        </div>
        <div className="relative">
          <input
            type="text"
            name="partner"
            value={messages}
            className="mt-1 pr-3 py-2 w-full text-sm rounded-md shadow-sm border-red-500 text-red-500"
            disabled={businessPartnerError}
          />
          <button
            type="button"
            onClick={() => {
              if (selectedBusiness?.id) {
                requestListBusinessPartner(dispatch, {
                  page: 1,
                  businessID: selectedBusiness?.id,
                });
              }
            }}
            className="absolute inset-y-0 right-0 px-2 py-1 flex items-center"
          >
            <RefreshIcon className="w-6 h-6 text-blue-500" />
          </button>
        </div>
      </div>
    );
  };

  const onDownloadProgress = (progress) => {
    const { transferredBytes, totalBytes } = progress;
    if (!totalBytes) {
      setdownloadProgress(0);
    } else {
      setdownloadProgress(transferredBytes / totalBytes);
    }
  };

  const downloadBlob = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "download";
    const clickHandler = () => {
      setTimeout(() => {
        URL.revokeObjectURL(url);
        a.removeEventListener("click", clickHandler);
      }, 150);
    };
    a.addEventListener("click", clickHandler, false);
    a.click();
    return a;
  };

  const downloadFile = async (key) => {
    try {
      setdownloading(true);

      const request = downloadData({
        path: `public/${key}`,
        options: {
          useAccelerateEndpoint: true,
          onProgress: onDownloadProgress,
        },
      });

      downloadRef.current = request;
      const result = await request.result;
      const fileName = getAccountingFileName(key);

      downloadBlob(result.body, fileName);
    } catch (downloadError) {
      if (downloadError.message !== "canceled") {
        await handleDownloadError(key);
      }
    } finally {
      setdownloading(false);
      setdownloadProgress(0);
    }
  };

  const handleDownloadError = async (key) => {
    try {
      const urlResult = await getUrl({
        path: `public/${key}`,
        options: {
          useAccelerateEndpoint: true,
        },
      });
      const signedURL = urlResult.url.href;
      window.open(signedURL);
    } catch (signedURLError) {
      setdownloadDocError(signedURLError);
    }
  };

  const renderFileModal = () => (
    <Modal
      title="Download File"
      show={downloading}
      onClose={() => {
        if (downloadRef.current) {
          const downloadTask = downloadRef.current;
          downloadTask.cancel();
        }
        setdownloading(false);
      }}
      footer={
        <div className="p-4 flex flex-row-reverse gap-2 justify-between items-center border-t border-gray-300 bg-gray-50 rounded-b-lg">
          <div className="flex-1 overflow-hidden">
            <div className="w-full">
              <p className="text-xs text-slate-500">{t("Downloading")}</p>
              <div className="w-full mt-1 bg-gray-200 rounded-md sm:rounded-lg dark:bg-gray-700">
                <div
                  className="bg-blue-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full"
                  style={{
                    width: `${Math.round(downloadProgress * 100)}%`,
                  }}
                >
                  {Math.round(downloadProgress * 100)}%
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    >
      <div className="bg-white p-4">
        <div className="flex justify-center">
          <DocumentIcon className="h-24 w-24 text-slate-500" />
        </div>
      </div>
    </Modal>
  );

  const renderDownloadError = () => {
    if (downloadDocError) {
      return (
        <ModalConfirm
          open={showDownloadErrorModal}
          type="ALERT"
          setOpen={(open) => {
            setshowDownloadErrorModal(open);
          }}
          title="Error"
          description={getErrorMessages(downloadDocError)}
          onConfirm={() => {
            setdownloadDocError(null);
          }}
        />
      );
    }
    return null;
  };

  const EmptyAccount = () => {
    return initAccountLoading ? (
      <InputSkeleton rows={2} />
    ) : (
      <EmptyState
        className="max-w-full"
        titleKey="No Accounts"
        descriptionKey="Please create an account first"
      >
        <div className="flex flex-col sm:flex-row justify-between gap-4 sm:gap-6">
          <Button
            outline
            className="flex-1"
            onClick={handleInitAccount}
            title="Create Automatically"
            data-testid="create-new-account"
          />

          <Button
            outline
            className="flex-1"
            onClick={() =>
              navigate(`/account/import?id=${selectedBusiness.id}`)
            }
            title="Import Using XLSX File"
          />
        </div>
      </EmptyState>
    );
  };

  if (businesses.length > 0) {
    return (
      <div className="max-w-4xl grid grid-cols-1 gap-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-3">
        {renderFileModal()}
        {renderDownloadError()}
        <div className="lg:col-start-3 lg:col-span-1">
          <div className="flex flex-col gap-4 p-4 rounded-lg bg-white">
            <div className="flex flex-col gap-4">
              <p className="font-medium text-gray-900">
                {t("Import Transactions via Excel")}
              </p>
              <p className="text-sm text-gray-700">
                {t("Download the")}{" "}
                <button
                  onClick={() =>
                    downloadFile("template/buku_kas_template.xlsx")
                  }
                  className="text-blue-600"
                >
                  {t("Excel format")}.
                </button>{" "}
                {t(
                  "Modify the Excel file according to your transaction data and upload it using the form below."
                )}
              </p>
            </div>
            <div className="flex gap-4">
              <div className="flex-1 overflow-hidden">
                <div className="flex">
                  <label
                    htmlFor="upload-input"
                    className={classNames(
                      fileError
                        ? "border-red-500 focus:border-red-500 focus:ring-red-500"
                        : "focus:ring-blue-500 focus:border-blue-500 border-gray-300",
                      "items-center whitespace-nowrap px-4 py-2 bg-gray-100 border-y border-l border-gray-300 rounded-l-md cursor-pointer text-sm text-gray-600 hover:bg-gray-200 active:bg-blue-50 focus:outline-none disabled:opacity-25 transition"
                    )}
                    onDragOver={handleDragOver}
                    onDrop={handleFileUpload}
                    onDragLeave={handleDragLeave}
                  >
                    {t("Choose File")}
                    <input
                      type="file"
                      id="upload-input"
                      className="sr-only"
                      onChange={handleFileUpload}
                      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    />
                  </label>
                  <div
                    className={classNames(
                      fileError
                        ? "border-red-500 focus:border-red-500 focus:ring-red-500"
                        : "focus:ring-blue-500 focus:border-blue-500 border-gray-300",
                      "flex w-full border rounded-r-md px-4 py-2 overflow-hidden"
                    )}
                    onDragOver={handleDragOver}
                    onDrop={handleFileUpload}
                    onDragLeave={handleDragLeave}
                  >
                    <span className="align-middle text-gray-400 text-sm truncate">
                      {selectedFile?.name || t("File not selected")}
                    </span>
                  </div>
                </div>
                {fileError && (
                  <div className="mt-1 text-red-600 text-sm">
                    {t(fileError)}
                  </div>
                )}
              </div>
              <div>
                <Button
                  onClick={() => handleImportClick(selectedFile)}
                  title={t("Upload")}
                  disabled={uploadLoading}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg lg:col-start-1 lg:col-span-2">
          {renderPartnerModal()}
          {((newTransaction?.id && !accountingSync) || uploadSuccess) && (
            <ModalConfirm
              data-testid="modal-open"
              open={showCashbookSuccess}
              setOpen={(open) => {
                setshowCashbookSuccess(open);
              }}
              title="Success"
              description={
                uploadSuccess
                  ? "Successfully uploaded Excel document."
                  : "Your transaction has been created."
              }
              type="SUCCESS"
              onConfirm={navigateToTransaction}
            />
          )}

          {newTransaction?.id && submitError && (
            <ModalConfirm
              data-testid="modal-open"
              open={showCashbookSuccess}
              setOpen={(open) => {
                setshowCashbookSuccess(open);
              }}
              title="Warning"
              description="Your transaction has been created but failed to sync to accounting."
              type="WARNING"
            />
          )}

          {((newTransaction?.id && transactionID) || transactionID) && (
            <ModalConfirm
              data-testid="modal-open"
              open={showSyncSuccess}
              setOpen={(open) => {
                setshowSyncSuccess(open);
              }}
              title="Success"
              description="Your transaction has been created and successfully synchronized to accounting."
              type="SUCCESS"
              onConfirm={navigateToTransaction}
            />
          )}

          {uploadLoading && renderProgressModal()}

          {uploadError && (
            <ModalConfirm
              data-testid="modal-open"
              open={showErrorModal}
              type="ALERT"
              setOpen={(open) => {
                setShowErrorModal(open);
              }}
              title="Error"
              description={getErrorMessages(uploadError)}
              onConfirm={() => {
                setShowErrorModal(false);
                clearDocumentExcelUpload(dispatch);
              }}
            />
          )}
          <div className="space-y-4 px-4 py-6">
            {selectedBusiness?.id && (
              <BusinessStatusBanner business={selectedBusiness} />
            )}
            {/* Only relevant while syncing — that is the only path that posts
                a journal into the closed period. */}
            {accountingSync && (
              <PeriodLockBanner businessID={selectedBusiness?.id} />
            )}
            {(fieldError || fieldErrorFile.status) && (
              <Alert
                title={fieldErrorFile.status ? "File Error" : "Incomplete Form"}
                type="warning"
                message={
                  fieldErrorFile.status
                    ? fieldErrorFile.message
                    : fieldError && selectedFile
                    ? "Business name is required."
                    : "Please fill out all fields."
                }
              />
            )}
            {(newTransactionError || submitError) && (
              <Alert
                title={
                  newTransactionError ? "Error" : "Error Sync to Accounting"
                }
                type="error"
                message={
                  newTransactionError
                    ? newTransactionError?.message ||
                      "Error create Transaction."
                    : submitError?.message ||
                      "Error sync transaction to accounting."
                }
                errors={newTransactionError?.errors || submitError?.message}
              />
            )}
            {newTransactionLoading || submitLoading ? (
              <InputSkeleton rows={5} />
            ) : (
              <>
                <div>
                  <FormLabel
                    htmlFor="businessID"
                    label={t("Business Name")}
                    required
                  />
                  <Select
                    className={classNames(
                      businessError
                        ? "border-red-500 focus:border-red-500 focus:ring-red-500"
                        : "border-gray-300 focus:border-blue-500 focus:ring-blue-500",
                      "mt-1 text-sm"
                    )}
                    classNamePrefix="select2-selection"
                    options={businesses}
                    placeholder={
                      businesses.length === 0
                        ? t("No Business Profile Yet")
                        : t("Select Business Name")
                    }
                    isLoading={businessLoading}
                    isDisabled={businesses.length === 0}
                    value={selectedBusiness}
                    onChange={setSelectedBusiness}
                  />
                  {businessError && (
                    <div className="mt-1 text-red-600 text-sm">
                      {t(businessError)}
                    </div>
                  )}
                </div>
                <div>
                  <FormLabel
                    htmlFor="type"
                    label={t("Transaction Type")}
                    className="text-base text-gray-900"
                    required
                  />
                  <fieldset className="mt-4">
                    <div className="space-y-4">
                      {transactionTypes.map((transactionType, index) => (
                        <div
                          key={transactionType.value}
                          className="flex items-center"
                        >
                          <input
                            name="type"
                            type="radio"
                            value={transactionType.value}
                            onChange={radioTransaction}
                            defaultChecked={
                              index === 0 || type === transactionType.value
                            }
                            className="focus:text-blue-600 h-4 w-4 text-blue-600 border-gray-300"
                          />
                          <label
                            htmlFor="type"
                            className="ml-3 block text-sm font-medium text-gray-700"
                          >
                            {t(transactionType.label)}
                          </label>
                        </div>
                      ))}
                    </div>
                  </fieldset>
                </div>
                <div>
                  <FormLabel htmlFor="date" label={t("Date")} required />
                  <ReactDatePicker
                    className={classNames(
                      dateError
                        ? "border-red-500 focus:border-red-500 focus:ring-red-500"
                        : "border-gray-300 focus:border-blue-500 focus:ring-blue-500",
                      "mt-1 block w-full text-sm rounded-md shadow-sm"
                    )}
                    selected={date}
                    onChange={setdate}
                    dateFormat="dd-MM-yyyy"
                    placeholderText={t("Select Date")}
                    // Constrained only while syncing to accounting: without the
                    // sync this date creates no journal, and restricting it
                    // would take away dates the user is entitled to.
                    minDate={accountingSync ? periodMinDate : undefined}
                    // A typed closed date is kept so the hint below names the period;
                    // the picker alone would drop it silently.
                    onChangeRaw={(event) => {
                      const typed = parseTypedClosedDate(
                        event?.target?.value,
                        "dd-MM-yyyy",
                        accountingSync ? isDateClosed : undefined,
                      );
                      if (typed) setdate(typed);
                    }}
                  />
                  {accountingSync && periodClosed && (
                    <p className="mt-1 text-xs text-amber-700">
                      {dateLocked
                        ? t("accounting.period.hints.dateLocked", {
                            date: closedThroughLabel,
                          })
                        : t("accounting.period.banner.closedThrough", {
                            date: closedThroughLabel,
                          })}
                    </p>
                  )}
                  {dateError && (
                    <div className="mt-1 text-red-600 text-sm">
                      {t(dateError)}
                    </div>
                  )}
                </div>
                <div>
                  <FormLabel htmlFor="total" label={t("Total")} required />
                  <NumericFormat
                    type="text"
                    name="total"
                    id="total"
                    data-testid="total"
                    value={total.value || ""}
                    placeholder={t("Enter Total Transaction")}
                    thousandSeparator="."
                    decimalSeparator=","
                    displayType="input"
                    prefix={"Rp"}
                    onValueChange={(values) => settotal(values)}
                    className={classNames(
                      totalError
                        ? "border-red-500 focus:border-red-500 focus:ring-red-500"
                        : "border-gray-300 focus:border-blue-500 focus:ring-blue-500",
                      "mt-1 block w-full text-sm rounded-md shadow-sm"
                    )}
                  />
                  {totalError && (
                    <div className="mt-1 text-red-600 text-sm">
                      {t(totalError)}
                    </div>
                  )}
                </div>
                <div>
                  <FormLabel htmlFor="note" label={t("Note")} />
                  <input
                    type="text"
                    name="note"
                    data-testid="note"
                    value={note}
                    placeholder={t("Enter Transaction Note")}
                    onChange={(e) => setnote(e.target.value)}
                    className="mt-1 block w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                  />
                </div>
                {businessPartnerError ? (
                  renderPartnerError(businessPartnerError)
                ) : (
                  <div>
                    <div className="flex justify-between">
                      <FormLabel
                        htmlFor="partner"
                        label={t("Partner or Customer")}
                      />
                      {businessIdParam && (
                        <button
                          type="button"
                          onClick={() => {
                            setshowPartnerModal(true);
                            resetPartnerModal();
                          }}
                          className="text-sm font-medium text-blue-600"
                        >
                          {t("Add Partner")}
                        </button>
                      )}
                    </div>
                    <Select
                      id="partner"
                      className="mt-1 text-sm"
                      classNamePrefix="select2-selection"
                      options={businessPartners.map((item) => ({
                        value: item.id,
                        label: item.name,
                      }))}
                      value={selectedPartner}
                      onChange={(selectedOption) => {
                        setselectedPartner(selectedOption);
                      }}
                      placeholder={t("Select Partner or Customer")}
                      maxMenuHeight={150}
                      menuPortalTarget={document.body}
                      isLoading={businessPartnerLoading}
                      isDisabled={businessPartnerLoading}
                      isClearable
                    />
                  </div>
                )}
                <div>
                  <label
                    htmlFor="accounting-sync-enabled"
                    className="block text-sm font-medium text-gray-700"
                  >
                    {t("Sync")}
                  </label>
                  <Field
                    as="div"
                    className="flex items-center mt-1 py-2 px-3 border border-gray-300 rounded-md"
                  >
                    <Switch
                      checked={accountingSync}
                      onChange={setaccountingSync}
                      className={classNames(
                        accountingSync ? "bg-blue-600" : "bg-gray-200",
                        "relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                      )}
                    >
                      <span className="sr-only">Use setting</span>
                      <span
                        className={classNames(
                          accountingSync ? "translate-x-5" : "translate-x-0",
                          "pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"
                        )}
                      >
                        <span
                          className={classNames(
                            accountingSync
                              ? "opacity-0 ease-out duration-100"
                              : "opacity-100 ease-in duration-200",
                            "absolute inset-0 h-full w-full flex items-center justify-center transition-opacity"
                          )}
                          aria-hidden="true"
                        >
                          <svg
                            className="h-3 w-3 text-gray-400"
                            fill="none"
                            viewBox="0 0 12 12"
                          >
                            <path
                              d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                        <span
                          className={classNames(
                            accountingSync
                              ? "opacity-100 ease-in duration-200"
                              : "opacity-0 ease-out duration-100",
                            "absolute inset-0 h-full w-full flex items-center justify-center transition-opacity"
                          )}
                          aria-hidden="true"
                        >
                          <svg
                            className="h-3 w-3 text-blue-600"
                            fill="currentColor"
                            viewBox="0 0 12 12"
                          >
                            <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                          </svg>
                        </span>
                      </span>
                    </Switch>
                    <Label as="span" className="ml-3">
                      <div>
                        <span className="text-sm text-gray-900">
                          {t("Sync to Accounting")}
                        </span>
                      </div>
                    </Label>
                  </Field>
                </div>
                {selectedBusiness?.id &&
                accountingSync &&
                accounts.length === 0 ? (
                  accountLoading ? (
                    <InputSkeleton rows={2} />
                  ) : accountError ? (
                    <Alert
                      title="Error"
                      type="error"
                      message={
                        accountError?.message ||
                        "Error fetch accounting account."
                      }
                      errors={accountError?.errors}
                    />
                  ) : (
                    <EmptyAccount />
                  )
                ) : (
                  selectedBusiness?.id &&
                  accountingSync && (
                    <>
                      <div>
                        <FormLabel
                          htmlFor="debitAccount"
                          label={t(
                            transactionType?.debitLabel || "Debit Account"
                          )}
                          required
                        />
                        <Select
                          name="debitAccount"
                          className={classNames(
                            debitAccountError
                              ? "border border-red-500 focus:border-red-500 focus:ring-red-500"
                              : "border-gray-300 focus:border-blue-500 focus:ring-blue-500",
                            "mt-1 block w-full text-sm rounded-md shadow-sm"
                          )}
                          classNamePrefix="select2-selection"
                          value={debitAccount}
                          onChange={setDebitAccount}
                          options={debits
                            .slice()
                            .sort(sortAccountCode)
                            .map((obj) => ({
                              value: obj.id,
                              label: `${obj.code} - ${obj.name}`,
                            }))}
                          placeholder={t("Choose Debit Account")}
                          isDisabled={!transactionType || debitLoading}
                          isLoading={debitLoading}
                          menuPortalTarget={document.body}
                          maxMenuHeight={150}
                        />
                        {debitError && (
                          <p className="mt-1 text-sm text-red-500">
                            {debitError.message}
                          </p>
                        )}
                        {debitAccountError && (
                          <p className="mt-1 text-red-600 text-sm">
                            {t(debitAccountError)}
                          </p>
                        )}
                      </div>
                      <div>
                        <FormLabel
                          htmlFor="creditAccount"
                          label={t(
                            transactionType?.creditLabel || "Credit Account"
                          )}
                          required
                        />
                        <Select
                          name="creditAccount"
                          className={classNames(
                            creditAccountError
                              ? "border border-red-500 focus:border-red-500 focus:ring-red-500"
                              : "border-gray-300 focus:border-blue-500 focus:ring-blue-500",
                            "mt-1 block w-full text-sm rounded-md shadow-sm"
                          )}
                          classNamePrefix="select2-selection"
                          options={credits
                            .slice()
                            .sort(sortAccountCode)
                            .map((obj) => ({
                              value: obj.id,
                              label: `${obj.code} - ${obj.name}`,
                            }))}
                          value={creditAccount}
                          onChange={setCreditAccount}
                          placeholder={t("Choose Credit Account")}
                          isDisabled={!transactionType || creditLoading}
                          isLoading={creditLoading}
                          menuPortalTarget={document.body}
                          maxMenuHeight={150}
                        />
                        {creditError && (
                          <p className="mt-1 text-sm text-red-500">
                            {creditError.message}
                          </p>
                        )}
                        {creditAccountError && (
                          <p className="mt-1 text-red-600 text-sm">
                            {t(creditAccountError)}
                          </p>
                        )}
                      </div>
                    </>
                  )
                )}
              </>
            )}
          </div>
          <div className="bg-gray-50 rounded-b-md sm:rounded-b-lg p-4 text-right">
            <Button
              title={
                submitError ? t("Sync to Accounting") : t("Create Transaction")
              }
              loading={
                newTransactionLoading || businessLoading || submitLoading
              }
              disabled={
                newTransactionLoading ||
                businesses.length === 0 ||
                submitLoading ||
                (accountingSync && dateLocked) ||
                isBusinessWriteBlocked(selectedBusiness)
              }
              onClick={submitError ? onAccountingSync : onCreate}
              data-testid="create-new-cashbook"
            />
          </div>
        </div>
      </div>
    );
  }

  return <EmptyBusiness loading={businessLoading} />;
};
